import type { NodeCategory } from '@/domain/funnel/node-system';
import { CATEGORY_LABELS } from '@/features/funnel-editor/nodes/registry/node-registry';

export interface StageFocusControlProps {
  categories: readonly NodeCategory[];
  active: NodeCategory | null;
  onSelect: (category: NodeCategory | null) => void;
}

/** SPEC-011 §51-56/plan §26 — a pure category select; "Overview" clears focus. */
export function StageFocusControl({ categories, active, onSelect }: StageFocusControlProps) {
  return (
    <label className="flex items-center gap-2 text-xs text-text-secondary">
      Foco da etapa
      <select
        aria-label="Foco da etapa"
        value={active ?? ''}
        onChange={(e) => onSelect(e.target.value ? (e.target.value as NodeCategory) : null)}
        className="rounded-md border border-border bg-surface-2 px-2 py-1 text-xs text-text-primary"
      >
        <option value="">Visão geral</option>
        {categories.map((category) => (
          <option key={category} value={category}>
            {CATEGORY_LABELS[category]}
          </option>
        ))}
      </select>
    </label>
  );
}
